/* @flow */

import { compose } from 'ramda';
import { connect } from 'react-redux';

import RetrieveUsernameSectionDumb from './RetrieveUsernameSectionDumb';
import { resetRetrievedUsername } from 'src/shared/app/authentication/action/support/supportRetrieveUsernameActions';
import { isUsernameRetrieved } from 'src/shared/app/authentication/selector/support/appRetrieveUsernameSelector';
import withMount from 'src/shared/app/base/component/hoc/withMount';

import type { State } from 'src/shared/core/type/reduxTypes';

const mapStateToProps = (state: State): Object => ({
  isUsernameRetrieved: isUsernameRetrieved(state),
});

const mapDispatchToProps = (dispatch: any): Object => ({ dispatch });

const mergeProps = (stateProps: Object, { dispatch }: Object): Object => ({
  ...stateProps,
  handleMount() {
    dispatch(resetRetrievedUsername());
  },
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  withMount,
)(RetrieveUsernameSectionDumb);
